import React from 'react';
import { createRoot } from 'react-dom/client';
import { LargeCartPopUp } from '../../components/LargeCartPopUp';

/***
    Test cases:
     - check if a large order uses tempCart api (redirect is set to cart) + toast is visible
     - check if a large order uses tempCart api (redirect is set to checkout) + toast is visible
     - check if a small order uses order api (redirect is set to cart)
     - check if a small order uses order api (redirect is set to checkout)
     - check if large order flow still works when csv upload storefront extension doesn't exist

    tempCart api: "/app/csvupload/tempcart"
    order api: "/extension/order"
***/

export const renderLargeCartPopup = async () => {
    const root = document.createElement('div');
    document.body.appendChild(root);
    createRoot(root).render(<LargeCartPopUp />);
};